// Agent Marketing — Real testimonials (attribution provided by client).
// Quotes are short, grounded, and non-hyperbolic.

export const testimonials = [
  {
    quote:
      "My website, listings, and profiles finally look like they belong to the same business.",
    name: "Dalen Hedges",
    company: "Hedges Realty",
    role: "Real Estate",
  },
  {
    quote:
      "I stopped losing referrals because there was nowhere to send them. That gap is gone.",
    name: "Justin Murray",
    company: "Murray Mortgages",
    role: "Mortgage",
  },
];
